module.exports = __webpack_public_path__ + "img/1080_15.42b52328.jpg";